import React from "react";
import Contact from "../Contact/Contact";
import Features from "../Features/Features";
import HeroSection from "../HeroSection/HeroSection";
import Projects from "../Projects/Projects";

const Home = () => {
  return (
    <div className="Home">
      <HeroSection />
      <Features />
      <Projects />
      <Contact />
    </div>
  );
};

export default Home;
